"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M11 16.5a7.5 7.5 0 016.785-7.466 9 9 0 10-17.01 5.624l-.762 5.329 5.329-.761A8.968 8.968 0 009 20c.929 0 1.825-.14 2.668-.402A7.474 7.474 0 0111 16.5z\" fill=\"#000\"></path><path d=\"M23.527 18.735a5.5 5.5 0 10-2.791 2.791l3.256.466-.465-3.257z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;